import { createContext, useContext, useState } from "react";

const dict = {
  fr: {
    nav_boat: "Le bateau", nav_excursions: "Excursions", nav_book: "Réserver", nav_admin: "Espace admin",
    hero_kicker: "Blue Army — Location bateau privé",
    hero_title: "Le lagon de Maurice, rien que pour vous",
    hero_sub: "Speedboat 28 pieds, skipper inclus. Nord & Ouest Maurice. Confort & performance.",
    hero_cta: "Faire une demande", hero_cta2: "Voir les excursions",
    hero_promise: "Réponse sous 24 h · Acompte en ligne via Juice",
    loc_label: "Location", loc_boat: "Bateau entier", loc_from: "À partir de Rs 25 000", loc_min: "Minimum : journée",
    incl_title: "Inclus dans chaque sortie",
    incl: ["Skipper pro", "Carburant", "Sécurité", "Équipement snorkeling"],
    exc_kicker: "Île aux Bénitiers — Jolly Roger LTD",
    exc_title: "Nos excursions exclusives",
    exc1_label: "Excursion 1", exc1_name: "Balade Bénitier Classic",
    exc1_lead: "Repas inclus — BBQ poisson, poulet, salades, boissons",
    exc1_points: ["Snorkeling à Crystal Rock", "Observation des dauphins", "Formule tout inclus — journée"],
    exc1_option: "Option langouste / écrevisse en supplément",
    exc1_extra: "Repas froid haut de gamme · Plateau fruits de mer",
    exc2_label: "Excursion 2", exc2_name: "Sunset Champagne",
    exc2_lead: "Croisière coucher de soleil",
    exc2_points: ["Ambiance coucher de soleil & vue panoramique", "Moment privilégié, apéritif au coucher du jour"],
    exc2_option: "Option champagne français",
    exc2_extra: "Plateau apéritif froid haut de gamme",
    choose: "Choisir cette excursion",
    how_title: "Comment ça marche",
    how: [["Votre demande", "Choisissez la sortie, la date et vos options."], ["Notre accord sous 24 h", "Nous vérifions la disponibilité et vous envoyons le prix."], ["Acompte via Juice", "Réglez l'acompte en ligne pour bloquer votre date."]],
    form_title: "Demande de réservation",
    form_sub: "Sans engagement. Nous vous répondons par e-mail sous 24 heures.",
    f_excursion: "Excursion", f_date: "Date souhaitée", f_guests: "Nombre de personnes", f_options: "Options",
    f_name: "Nom complet", f_email: "E-mail", f_phone: "Téléphone / WhatsApp", f_message: "Message (facultatif)",
    f_submit: "Envoyer ma demande", f_sending: "Envoi…",
    f_booked: "Cette date vient d'être réservée, merci d'en choisir une autre.",
    f_pick_date: "Choisissez une date", cal_free: "Disponible", cal_booked: "Déjà réservé",
    f_error: "Merci de vérifier les champs du formulaire.",
    exc_names: { location: "Location bateau entier (journée)", classic: "Balade Bénitier Classic", sunset: "Sunset Champagne" },
    options: { langouste: "Langouste / écrevisse", repas_froid: "Repas froid haut de gamme", plateau_fruits_mer: "Plateau fruits de mer", champagne: "Champagne français", plateau_aperitif: "Plateau apéritif froid haut de gamme" },
    sent_title: "Demande envoyée !",
    sent_body: "Merci ! Vous allez recevoir un e-mail de confirmation. Nous vous répondons sous 24 heures.",
    sent_track: "Suivre ma demande",
    footer_contact: "Contact",
    footer_area: "Nord & Ouest Maurice · Skipper inclus",
    tr_title: "Votre réservation",
    tr_loading: "Chargement…", tr_notfound: "Réservation introuvable.",
    status: { pending: "En attente de réponse", approved: "Acceptée — acompte à régler", payment_submitted: "Paiement en vérification", confirmed: "Confirmée", declined: "Non disponible" },
    tr_pending: "Nous avons bien reçu votre demande. Réponse au plus tard le",
    tr_total: "Prix total", tr_deposit: "Acompte à régler", tr_balance: "Solde le jour de la sortie",
    pay_title: "Payer l'acompte avec Juice",
    pay_steps: ["Ouvrez l'application MCB Juice", "Choisissez « Transfert » vers le numéro ci-dessous", "Indiquez la référence de réservation en libellé", "Saisissez ici la référence de transaction reçue"],
    pay_number: "Numéro Juice", pay_holder: "Bénéficiaire", pay_ref_label: "Libellé à indiquer",
    pay_tx: "Référence de transaction Juice", pay_payer: "Nom du payeur", pay_submit: "J'ai payé l'acompte",
    pay_pending_num: "Le numéro Juice vous sera communiqué par WhatsApp.",
    pay_submitted: "Merci ! Nous vérifions la réception de votre acompte et confirmons votre réservation par e-mail.",
    tr_confirmed: "Votre sortie est confirmée. À bientôt à bord !",
    tr_declined: "Désolés, nous ne pouvons pas assurer cette date. Contactez-nous sur WhatsApp pour une alternative.",
    tr_note: "Message du capitaine",
    back_home: "Retour au site",
  },
  en: {
    nav_boat: "The boat", nav_excursions: "Excursions", nav_book: "Book", nav_admin: "Admin",
    hero_kicker: "Blue Army — Private boat charter",
    hero_title: "The Mauritian lagoon, all to yourself",
    hero_sub: "28-foot speedboat, skipper included. North & West Mauritius. Comfort & performance.",
    hero_cta: "Request a booking", hero_cta2: "See excursions",
    hero_promise: "Reply within 24h · Online deposit via Juice",
    loc_label: "Charter", loc_boat: "Whole boat", loc_from: "From Rs 25,000", loc_min: "Minimum: full day",
    incl_title: "Included in every trip",
    incl: ["Pro skipper", "Fuel", "Safety", "Snorkeling gear"],
    exc_kicker: "Île aux Bénitiers — Jolly Roger LTD",
    exc_title: "Our exclusive excursions",
    exc1_label: "Excursion 1", exc1_name: "Bénitier Classic Cruise",
    exc1_lead: "Meal included — BBQ fish, chicken, salads, drinks",
    exc1_points: ["Snorkeling at Crystal Rock", "Dolphin watching", "All-inclusive — full day"],
    exc1_option: "Lobster / crayfish option at extra cost",
    exc1_extra: "Premium cold meal · Seafood platter",
    exc2_label: "Excursion 2", exc2_name: "Sunset Champagne",
    exc2_lead: "Sunset cruise",
    exc2_points: ["Sunset atmosphere & panoramic views", "A special moment, aperitif at dusk"],
    exc2_option: "French champagne option",
    exc2_extra: "Premium cold aperitif platter",
    choose: "Choose this excursion",
    how_title: "How it works",
    how: [["Your request", "Pick the trip, the date and your options."], ["Our answer within 24h", "We check availability and send you the price."], ["Deposit via Juice", "Pay the deposit online to secure your date."]],
    form_title: "Booking request",
    form_sub: "No commitment. We reply by email within 24 hours.",
    f_excursion: "Excursion", f_date: "Preferred date", f_guests: "Number of guests", f_options: "Options",
    f_name: "Full name", f_email: "Email", f_phone: "Phone / WhatsApp", f_message: "Message (optional)",
    f_submit: "Send my request", f_sending: "Sending…",
    f_booked: "This date has just been booked, please choose another one.",
    f_pick_date: "Pick a date", cal_free: "Available", cal_booked: "Already booked",
    f_error: "Please check the form fields.",
    exc_names: { location: "Full boat charter (day)", classic: "Bénitier Classic Cruise", sunset: "Sunset Champagne" },
    options: { langouste: "Lobster / crayfish", repas_froid: "Premium cold meal", plateau_fruits_mer: "Seafood platter", champagne: "French champagne", plateau_aperitif: "Premium cold aperitif platter" },
    sent_title: "Request sent!",
    sent_body: "Thank you! You will receive a confirmation email. We reply within 24 hours.",
    sent_track: "Track my request",
    footer_contact: "Contact",
    footer_area: "North & West Mauritius · Skipper included",
    tr_title: "Your booking",
    tr_loading: "Loading…", tr_notfound: "Booking not found.",
    status: { pending: "Awaiting reply", approved: "Accepted — deposit due", payment_submitted: "Payment being checked", confirmed: "Confirmed", declined: "Not available" },
    tr_pending: "We have received your request. Reply at the latest by",
    tr_total: "Total price", tr_deposit: "Deposit due", tr_balance: "Balance on the day",
    pay_title: "Pay the deposit with Juice",
    pay_steps: ["Open the MCB Juice app", "Choose “Transfer” to the number below", "Add the booking reference as description", "Enter the transaction reference here"],
    pay_number: "Juice number", pay_holder: "Beneficiary", pay_ref_label: "Description to add",
    pay_tx: "Juice transaction reference", pay_payer: "Payer name", pay_submit: "I have paid the deposit",
    pay_pending_num: "The Juice number will be sent to you on WhatsApp.",
    pay_submitted: "Thank you! We are checking your deposit and will confirm your booking by email.",
    tr_confirmed: "Your trip is confirmed. See you on board!",
    tr_declined: "Sorry, we cannot operate on this date. Contact us on WhatsApp for an alternative.",
    tr_note: "Message from the captain",
    back_home: "Back to site",
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("jr_lang") || "fr");
  const setLang = (l) => { localStorage.setItem("jr_lang", l); setLangState(l); };
  return <LangContext.Provider value={{ lang, setLang, t: dict[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const CONTACT = { whatsapp: "+33 6 69 49 05 05", whatsappLink: "https://wa.me/33669490505", email: "Jckrose@hotmail.fr" };

export const EXC_OPTIONS = {
  location: [],
  classic: ["langouste", "repas_froid", "plateau_fruits_mer"],
  sunset: ["champagne", "plateau_aperitif"],
};

export const formatRs = (n) => `Rs ${Math.round(n || 0).toLocaleString("fr-FR")}`;
